import axios from "axios";
import { getAccessToken } from "../utils/tokenManager";

const API_BASE_URL = process.env.REACT_APP_API_URL

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: API_BASE_URL ,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    platform: "web-client",
  },
});

// Request interceptor to add Authorization header
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers["authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor for error handling (e.g. token refresh logic)
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.clear();
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
